import { type ColumnOrderState, flexRender } from "@tanstack/react-table";
import { Reorder } from "motion/react";
import { useCallback } from "react";
import { cn } from "../../utils";
import { useDataTableContext } from "./context";
import { DataTableTh } from "./data-table-th";
import type { Header } from "./types";

/** Props Interface */
interface DataTableHeaderProps {
	setColumnOrder: (state: ColumnOrderState) => void;
}

export function DataTableHeader({ setColumnOrder }: DataTableHeaderProps) {
	const { table } = useDataTableContext();

	const handleOnReorder = useCallback(
		(headers: Header<any, unknown>[]) => {
			setColumnOrder(headers.map((header) => header.column.id));
		},
		[setColumnOrder],
	);

	return (
		<div className="table-head z-2">
			{table.getHeaderGroups().map((headerGroup) => (
				<Reorder.Group
					key={headerGroup.id}
					className={cn("table-row")}
					values={headerGroup.headers}
					onReorder={handleOnReorder}
					axis="x"
					as="div"
					layoutScroll
				>
					{headerGroup.headers.map((header) => (
						<DataTableTh
							header={header}
							key={header.column.id}
						>
							{flexRender(header.column.columnDef.header, header.getContext())}
						</DataTableTh>
					))}
				</Reorder.Group>
			))}
		</div>
	);
}
